module.exports = __webpack_public_path__ + "static/media/prescription.89ce7f94.svg";